import * as React from 'react'

const SvgTechnologyIcon = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="10" fill="#444CE7" />
    <path
      d="M21 14V16M27 14V16M21 32V34M27 32V34M32 21H34M32 26H34M14 21H16M14 26H16M20.8 32H27.2C28.8802 32 29.7202 32 30.362 31.673C30.9265 31.3854 31.3854 30.9265 31.673 30.362C32 29.7202 32 28.8802 32 27.2V20.8C32 19.1198 32 18.2798 31.673 17.638C31.3854 17.0735 30.9265 16.6146 30.362 16.327C29.7202 16 28.8802 16 27.2 16H20.8C19.1198 16 18.2798 16 17.638 16.327C17.0735 16.6146 16.6146 17.0735 16.327 17.638C16 18.2798 16 19.1198 16 20.8V27.2C16 28.8802 16 29.7202 16.327 30.362C16.6146 30.9265 17.0735 31.3854 17.638 31.673C18.2798 32 19.1198 32 20.8 32ZM22.6 27H25.4C25.9601 27 26.2401 27 26.454 26.891C26.6422 26.7951 26.7951 26.6422 26.891 26.454C27 26.2401 27 25.9601 27 25.4V22.6C27 22.0399 27 21.7599 26.891 21.546C26.7951 21.3578 26.6422 21.2049 26.454 21.109C26.2401 21 25.9601 21 25.4 21H22.6C22.0399 21 21.7599 21 21.546 21.109C21.3578 21.2049 21.2049 21.3578 21.109 21.546C21 21.7599 21 22.0399 21 22.6V25.4C21 25.9601 21 26.2401 21.109 26.454C21.2049 26.6422 21.3578 26.7951 21.546 26.891C21.7599 27 22.0399 27 22.6 27Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgTechnologyIcon
